import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { enabledProvidersSelector } from "./enabledProvidersSelector";

export const enabledProvidersArraySelector = createDraftSafeSelector(
  [enabledProvidersSelector],
  (providers) => {
    return Array.from(providers);
  },
);
